<template>
  <NebulaFieldGroup
    class="home-filter-dropdown"
    :input-id="inputId"
    :label-text="label"
  >
    <template #formElement>
      <NebulaSelect size="s">
        <template #select>
          <select
            class="nebula-select__element"
            :id="inputId"
            :value="selectedId"
            @change="selectOption"
          >
            <NebulaSelectOption
              v-for="option in options"
              :key="option.id"
              :option="{
                text: option.label,
                value: option.id,
              }"
            />
          </select>
        </template>
      </NebulaSelect>
    </template>
  </NebulaFieldGroup>
</template>

<script>
import { kebabCase } from 'lodash-es';
import { NebulaFieldGroup, NebulaSelect, NebulaSelectOption } from '@discoveryedu/nebula-components';

export default {
  name: 'HomeFilterDropdown',
  components: {
    NebulaFieldGroup,
    NebulaSelect,
    NebulaSelectOption,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedId: {
      type: String, // id of the selected option, or null for the default option
      default: null,
    },
  },
  emits: ['selectOption'],
  computed: {
    inputId() {
      const label = kebabCase(this.label);
      return `home-filter-dropdown__input--${label}`;
    },
    selectedOption() {
      let selectedOption;

      if (this.selectedId) {
        selectedOption = this.options.find((option) => option.id === this.selectedId);
      } else {
        selectedOption = this.options.find((option) => option.default);
      }

      return selectedOption;
    },
  },
  methods: {
    selectOption(e) {
      this.$emit('selectOption', e.target.value);
    },
  },
};
</script>

<style lang="stylus">
.home-filter-dropdown {}
</style>
